export default "__VITE_ASSET__COx1s$hm__"